import { Card, Divider, Pagination } from 'antd';
import { useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import SearchFilter from '../../component/Filter';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	getBlockchainNetworks,
	getCurrencies,
} from '../../methods/redux/reducers/currency';
import { getTransactionsOverview } from '../../methods/redux/reducers/transactions';
import { getUserProfileById } from '../../methods/redux/reducers/user-profile';
import remakeQueryString from '../../methods/utils/remake-query-string';
import Aggregate from './Aggregate';
import ColumnItem from './ColumnItem';

export const UsersListPage = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;

	& .myCard {
		border-radius: 10px;
		gap: 1em;
	}
`;
export const MainSection = styled(Card)`
	border-radius: 10px;
	gap: 2em;
`;

const TransactionOverview = () => {
	const dispatch = useAppDispatch();
	const { userId } = useParams();

	const [searchParams, setSearchParams] = useSearchParams();
	const { user } = useAppSelector((store) => store.userProfile);
	const { overview } = useAppSelector((store) => store.transactions);
	const { currencies } = useAppSelector((store) => store.currencies);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(overview.paginator.perPage),
			});
		}

		if (userId) {
			dispatch(getUserProfileById(userId));
		}

		dispatch(getCurrencies({}));
		dispatch(getBlockchainNetworks());
	}, []);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			if (userId) {
				dispatch(getTransactionsOverview({ ...queryData, userId }));
			} else {
				dispatch(getTransactionsOverview(queryData));
			}
		}
	}, [searchParams]);

	const currencySelect = currencies.map((item: any) => ({
		name: item.symbol,
		value: item._id,
	}));

	return (
		<Card>
			<h1>
				Transaction Statement Overview{' '}
				{userId && (
					<span>
						{' '}
						for{' '}
						<Link
							title="View Profile"
							to={`/user-profile/${user.profile?._id}`}
						>
							@{user.profile?.username}
						</Link>
					</span>
				)}
			</h1>

			<Aggregate data={overview.result} />

			<br />

			<SearchFilter
				title="Search Transaction Statements Overview"
				searchFilters={[
					{
						label: 'Currency',
						name: 'currencyId',
						htmlElement: 'select',
						selectOptions: currencySelect,
					},
					{
						label: 'Start Date',
						name: 'startDate',
						htmlElement: 'datepicker',
					},
					{
						label: 'End Date',
						name: 'endDate',
						htmlElement: 'datepicker',
					},
					{
						label: 'Transaction Form',
						name: 'form',
						htmlElement: 'select',
						selectOptions: [
							{ name: 'inApp Transfer', value: 'inapp_transfer' },
							{ name: 'Fixed Savings', value: 'fixed_savings' },
							{ name: 'Flexible Savings', value: 'flexible_savings' },
							{ name: 'Esusu', value: 'esusu_savings' },
							{ name: 'Referral Bonus', value: 'referral_bonus' },
							{ name: 'Swap', value: 'swap' },
							{ name: 'Staking', value: 'staking' },
							{ name: 'Promo', value: 'promo' },
							{ name: 'Bulk Job', value: 'bulk_job' },
							{ name: 'Blockchain', value: 'blockchain' },
							{ name: 'None', value: 'none' },
						],
					},
				]}
				retrieveQueryString={updateQueryString}
			/>

			<br />

			<p>
				Total of <strong>{overview.paginator.itemCount} items</strong> found
			</p>

			<br />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={overview.paginator.itemCount}
				current={overview.paginator.currentPage}
				pageSize={overview.paginator.perPage}
			/>
			<br />

			{overview.itemsList.map((item: any) => (
				<ColumnItem key={item?._id} data={item} />
			))}

			<Divider />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={overview.paginator.itemCount}
				current={overview.paginator.currentPage}
				pageSize={overview.paginator.perPage}
				showSizeChanger
				showQuickJumper
			/>
		</Card>
	);
};

export default TransactionOverview;
